import type { TimeRangeInputValue } from '@chronosphereio/core';
import { useState } from 'react';
import { usePinnedTimeRange, usePinnedTimeRangeStatus } from './pinned-time-range-hooks';
import { type TimeRangeProviderOptions } from './time-range-api';

export interface InMemoryTimeRangeStorage {
  timeRange: TimeRangeInputValue;
  setTimeRange: (next: TimeRangeInputValue) => void;
}

/**
 * Handles time range storage in-memory (i.e. React state).
 */
export function useInMemoryTimeRangeStorage(options: TimeRangeProviderOptions): InMemoryTimeRangeStorage {
  const { pinnedTimeRange } = usePinnedTimeRange();
  const { pinnedStatus } = usePinnedTimeRangeStatus();

  const [timeRange, setTimeRange] = useState(() => {
    return options.enablePinning && pinnedStatus === 'pinned' ? pinnedTimeRange : options.defaultTimeRange;
  });

  return {
    timeRange,
    setTimeRange,
  };
}
